// extracted by mini-css-extract-plugin
module.exports = {"block":"content_block__1BHB6","tabItem":"content_tabItem__1cmTA"};